const environments = {
  test: "openbravo/",
  live: "bharathi/",
  local: "BBS/"
};

const currentEnvironment = process.env.REACT_APP_ENV || "live";

const baseUrl = environments[currentEnvironment];

export default {
  baseUrl,
  Login: `${baseUrl}ws/com.digiopen.mobileapps.applogin`,
  organization: `${baseUrl}ws/com.digiopen.mobileapps.organization`,
  lineMaster: `${baseUrl}org.openbravo.service.json.jsonrest/DGM_Newlinemaster`,
  season: `${baseUrl}org.openbravo.service.json.jsonrest/DGM_Season`,
  warehouseData: `${baseUrl}org.openbravo.service.json.jsonrest/Warehouse`,
  DguRemoteIP: `${baseUrl}org.openbravo.service.json.jsonrest/dgu_remoteip`,
  fetchADUser: `${baseUrl}org.openbravo.service.json.jsonrest/ADUser`,


  realTimeLineActivity: `${baseUrl}ws/com.digiopen.mobileapps.realTimeLineActivity`,
  realTimeLineActivityLine: `${baseUrl}ws/com.digiopen.mobileapps.realTimeLineActivityLine`,
  realTimeLineActivityNonSeed: `${baseUrl}ws/com.digiopen.mobileapps.realTimeLineActivityNonSeed`,

  realTimeWarehouseActivity: `${baseUrl}ws/com.digiopen.mobileapps.realTimeWarehouseActivity`,
  realTimeWarehouseLine: `${baseUrl}ws/com.digiopen.mobileapps.realTimeWarehouseLine`,
  realTimeWarehouseCount: `${baseUrl}ws/com.digiopen.mobileapps.realTimeWarehouseCount`,

  drierStatusReport: `${baseUrl}ws/com.digiopen.mobileapps.drierStatusReport`,
  drierStatusReportEven: `${baseUrl}ws/com.digiopen.mobileapps.drierStatusReportEven`,
  drierStatusReportOdd: `${baseUrl}ws/com.digiopen.mobileapps.drierStatusReportOdd`,
  DryingTransactionTemp: `${baseUrl}org.openbravo.service.json.jsonrest/DGW_DryingTransactionTemp`,

  warehouseStatus: `${baseUrl}ws/com.digiopen.mobileapps.warehouseStatus`,
  warehouseStatusLineSeed: `${baseUrl}ws/com.digiopen.mobileapps.warehouseStatusLineSeed`,
  warehouseStatusLineNonSeed: `${baseUrl}ws/com.digiopen.mobileapps.warehouseStatusLineNonSeed`,

  screenname: `${baseUrl}org.openbravo.service.json.jsonrest/DGM_screenname`,
  screenReport: `${baseUrl}ws/com.digiopen.mobileapps.screenReport`,
  
  TimeLineReport: `${baseUrl}org.openbravo.service.json.jsonrest/DGW_DryingTransactionTemp`,
  Organization: `${baseUrl}org.openbravo.service.json.jsonrest/Organization`,
  Season: `${baseUrl}org.openbravo.service.json.jsonrest/DGM_Season`, 
  DGM_Binmaster:`${baseUrl}org.openbravo.service.json.jsonrest/DGM_Binmaster`,
  DRYING: `${baseUrl}org.openbravo.service.json.jsonrest/DGW_Drying`,
  BinBatch: `${baseUrl}org.openbravo.service.json.jsonrest/DGM_BinBatch`,
  DRYINGLINE: `${baseUrl}org.openbravo.service.json.jsonrest/DGW_Dryingline`,
  getImage: `${baseUrl}utility/ShowImage`,
  testserver: `http://185.214.134.4:8080/`,
  local:`http://192.168.1.46:8080/`,
  Newliveserver: `http://80.241.215.65:8080/`,
  oldliveserver:`https://whm.bharathiseeds.com/`
};

// New live server: http://80.241.215.65:8080/
// old live server: https://whm.bharathiseeds.com/
// test server: http://185.214.134.4:8080/